import { Navigate, useLocation } from 'react-router-dom';
import { resolveLegacyPath } from './legacyRedirects.generated';
import { NotFoundPage } from '@/features/pages/NotFoundPage';

/**
 * Rete di sicurezza client-side per gli URL vecchi.
 *
 * IL 301 VERO LO FA NGINX (`docker/nginx/redirects.map`). Questo componente
 * copre solo i casi in cui un percorso legacy arriva al router con la SPA già
 * caricata: un link interno rimasto vecchio, la cronologia, un bookmark
 * aperto da dentro l'app. Non è un 301 e non va confuso con esso — è
 * `<Navigate replace>`, cioè un 200 lato HTTP.
 *
 * Se il percorso non è legacy, è un 404 vero.
 */
export function LegacyRedirect() {
  const location = useLocation();
  const target = resolveLegacyPath(location.pathname);

  if (target) {
    return <Navigate to={`${target}${location.search}`} replace />;
  }
  return <NotFoundPage />;
}
